<template>
	<div class="html" v-html="content"/>
</template>

<script>
import marked from "marked";

export default {
	props: {
		markdown: {type: String, required: true}
	},
	computed: {
		content: (t) => marked(t.markdown)
	}
};
</script>

<style  lang="scss" scoped>
.html {
	line-height: 24px;
	color: #363B40;

	/deep/ {
		a {
			color: #007ACE;
			text-decoration: underline;
		}
	}
}
</style>
